import { clearStorage as clearLivechatStorage } from '@inno-sdk/livechat-sdk'
import { performCleanup__INTERNAL__ } from '@inno-tools/container-bridge'
import { resetFilesSdkCache } from 'modules/desktop/modules/files-integration/api/filesSdk'
import { useLogoutMutation } from 'shared/api/auth/requests/logout/logout'
import { AuthBroadcastMessages } from 'shared/constants/broadcast/auth'
import { BroadcastChannels } from 'shared/constants/broadcast/channels'
import { LocalStorageKey } from 'shared/constants/localStorage'
import { APP_ROUTES } from 'shared/constants/routes'
import { SessionStorageKey } from 'shared/constants/sessionStorage'
import { logger } from 'shared/services/logger'
import { withAuthStorageReason } from 'shared/services/logger/utils/authDiagnostics'
import { postMessage } from 'shared/utils/broadcastChannel'
import { lsGetItem, lsRemoveItem } from 'shared/utils/local-storage'

export const useLogout = () => {
  const { mutateAsync: logout } = useLogoutMutation()

  const handleLogout = async (reason: string = 'unknown') => {
    logger.track('auth.logout_started', { reason })
    try {
      await logout({
        refresh_token: lsGetItem(LocalStorageKey.USER)?.refresh_token || ''
      })
    } finally {
      logger.track('auth.logout', {
        reason
      })

      await performCleanup__INTERNAL__()
      await clearLivechatStorage()

      sessionStorage.removeItem(SessionStorageKey.POST_LOGIN_REDIRECT)
      withAuthStorageReason(reason, () => lsRemoveItem(LocalStorageKey.USER))
      // Clear desktop items state
      lsRemoveItem(LocalStorageKey.DESKTOP_APP_FOLDER_ID)
      lsRemoveItem(LocalStorageKey.FEATURE_FLAGS_CACHE)
      // Drop the in-memory files SDK so a next user in the same tab can't reuse
      // an instance built with the previous user's access token.
      resetFilesSdkCache()
      postMessage(BroadcastChannels.AUTH, {
        type: AuthBroadcastMessages.LOGOUT
      })
      logger.track('auth.logout_completed', { reason })
      logger.clearActor()
      await logger.flush()
      window.location.href = APP_ROUTES.login.path
    }
  }

  return handleLogout
}
